
import eventTrackingMixins from '~/mixins/eventTrackingMixins.js';
import eventTrackingBlogAdvisorCardMixins from '~/mixins/eventTrackingBlogAdvisorCardMixin.js';
import whatsappFn from '~/mixins/whatsappFn.js';
import whatsappQuery from '@/apollo/queries/general/whatsappQuery';

export default {
    name: "BlogAdvisorDesktopCard",

    mixins: [eventTrackingMixins, eventTrackingBlogAdvisorCardMixins, whatsappFn],

    props: {
        advisorProfilePicture: {
            type: String,
            required: true
        },
        advisorName: {
            type: String,
            required: true
        },
        advisorCompany: {
            type: String,
            required: true
        },
        advisorProfile: {
            type: String,
            required: true
        },
        advisorContact: {
            type: String,
            required: true
        },
        advisorId: {
            type: Number,
            required: true
        },
        advisorRegistrationNo: {
            type: String,
            required: true
        }
    },

    apollo: {
        $loadingKey: 'loading',
        whatsappMsg: {
            prefetch: true,
            query: whatsappQuery,
            variables() {
                return { currentlocale: this.$normalizeLocale(this.$i18n.locale) };
            },
            update(data) {
                return this.$normalizeStrapi(data.whatsappWidgetItems);
            },
        },
    },

    data() {
        return {};
    },

    computed: {
        enqueryImgPath() {
            return require(`@/assets/images/advisor-blog/whatsapp-icon-desktop-${this.$i18n.locale}.png`)
        },
        msgText() {
            return `${this.whatsappUrl}${encodeURIComponent(this.msg)}`;
        },
        whatsappUrl() {
            return `https://api.whatsapp.com/send/?phone=852${this.advisorContact}&text=`;
        } 
    },

    methods: {
        showAdvisorProfile() {
            let language = this.$i18n.locale == "en" ? "en" : "tc";
            let link = process.env.ADVISOR_FRONTEND_URL+"/"+language+"/find-advisor/advisor/"+this.advisorId;
            window.open(link);

            const blugSlug = this.$route.params.slug;
            this.handleEventTracking_blogAdvisorCardProfile(this.$route.query.adid, blugSlug, this.advisorRegistrationNo);
        },
        async openWhatsapp() {
            const msgObj = this.whatsappMsg.find((item) => item.PlacementCode === 'blog-single-advisor-ad'); 
            let msg = msgObj?.Msg || '';

            const advisorName = this.advisorName;
            const blogUrl = location.toString().split('?')[0];
            const firstBlogCategoryDisplayName = this.getBlogFirstTag();
            msg = msg?.replace('{advisor_name}', advisorName).replace('{blog_url}', blogUrl).replace('{first_blog_category_display_name}', firstBlogCategoryDisplayName);
            
            const applyAdTrackingToWhatsappLink = async (link) => {
                const btnLink = this.whatsappUrl; 
                try {
                    if(this.isWhatsappLink(btnLink) && (this.hasAdsInCookies() || this.hasLgmadsInCookies())) {
                        const refData = await this.fetchWhatsappRefCode()
                        window.open(this.adjustWhatsappLink(btnLink, refData) + encodeURIComponent(msg), this.$device.isMobile ? '_self' : '_blank'); 
                        return true;
                    }
                    return false
                } catch (error) {
                    console.error('error: ', error);
                    this.$sentry.captureException(error);
                }
            }
            if(!await applyAdTrackingToWhatsappLink()) {
                window.open(`${this.whatsappUrl}${encodeURIComponent(msg)}`);
            }
            
            const blugSlug = this.$route.params.slug;
            this.handleEventTracking_blogAdvisorCardWhatsapp(this.$route.query.adid, blugSlug, this.advisorRegistrationNo);
        },
        getBlogFirstTag() {
            const tag = document.querySelector('.blog-single .tags .tag');
            return tag?.innerText ? tag.innerText : '';
        },
    },
}
